import { Component, OnInit, OnDestroy } from "@angular/core";
import { Container, ContainerService, ViewService, GeneratorService } from "src/app/common";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "app-container-detail-view",
  templateUrl: "./container-detail-view.component.html",
  styleUrls: ["./container-detail-view.component.css"],
  standalone: false,
})
export class ContainerDetailView implements OnInit, OnDestroy {
  container: Container;
  subscriptions: any[];
  errorMsg: any;
  generator: Generator;
  containerNumber: any;
  showPrintitems: boolean;
  isChecked: any;
  trackingNumber: string;

  constructor(
    public viewService: ViewService,
    private genratorService: GeneratorService,
    private containerService: ContainerService,
    private route: ActivatedRoute
  ) {
    this.subscriptions = [];

    viewService.setViewData({ pageTitle: "Container Detail" });
  }

  ngOnInit(): void {
    this.genratorService.getActive().subscribe((generators) => {
      this.generator = generators.data[0];
    });

    this.subscriptions.push(
      this.route.params.subscribe((params) => {
        this.containerNumber = params["containerId"];
        if (this.containerNumber) {
          this.containerService.get(this.containerNumber).subscribe((container) => {
            if (!container.canEdit) {
              this.viewService.back();
            } else {
              this.container = container;

              let editLink = container.canEdit
                ? { text: "» Edit", routeData: this.viewService.routerLink(["edit"]) }
                : undefined;
              this.viewService.setViewData({
                pageTitle: container.containerNumber,
                link: editLink,
              });
            }
          });
        } else {
          this.viewService.back();
        }
      })
    );
  }

  onPrint() {
    this.containerService.printLayout().subscribe((data) => console.log(data));
  }

  ngOnDestroy() {
    this.subscriptions.forEach((x) => x.unsubscribe());
  }
}
